import { z } from 'zod';

export const SelectedCurrencySchema = z.object({
  code: z.string(),
  symbol: z.string(),
  precision: z.number(),
});

export const UserCurrencyResponseSchema = z.object({
  code: z.string(),
  symbol: z.string().optional(),
  precision: z.number().optional(),
});

export const PivotCurrenciesResponseSchema = z.array(
  z.object({
    id: z.number(),
    label: z.string(),
  }),
);
